/* Psolys · « Écrire un avis » : 3 écrans (note et texte, signature, merci), la fenêtre sur l'accueil et la page produit,
   le formulaire posé sur /pages/avis. L'avis part par le formulaire contact de Shopify (e-mail à la boutique) sans quitter
   la page ; si Shopify demande une vérification anti-robot, le formulaire est envoyé normalement et le merci s'affiche au retour. */
(() => {
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const LABELS = ['', 'Décevant', 'Moyen', 'Bien', 'Très bien', 'Coup de cœur'];
  const MAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const initForm = form => {
    if (form.dataset.ready) return;
    form.dataset.ready = '1';
    form.classList.add('is-ready');
    const inner = $('[data-avis-inner]', form), scope = form.closest('[data-avis-scope]');
    const steps = $$('.avis-step', form);
    const show = n => {
      form.dataset.step = n;
      steps.forEach(s => s.classList.toggle('is-on', +s.dataset.step === n));
      if (scope) scope.classList.toggle('is-merci', n === 3);
      const dlg = form.closest('dialog'); if (dlg) dlg.classList.toggle('is-merci', n === 3);
      if (n < 3) { const f = $(`.avis-step[data-step="${n}"] ${n === 1 ? 'textarea' : 'input[type=text]'}`, form); if (f && form.offsetParent) setTimeout(() => f.focus({ preventScroll: true }), 380); }
    };
    const err = (n, msg) => { const e = $(`.avis-step[data-step="${n}"] [data-avis-error]`, form); if (e) { e.textContent = msg; e.hidden = !msg; } };
    const note = $('[data-avis-note]', form), label = $('[data-avis-note-label]', form);
    $$('input[name="avis-note"]', form).forEach(r => r.addEventListener('change', () => { note.value = `${r.value} sur 5`; label.textContent = LABELS[r.value]; }));
    const text = form.elements['contact[body]'];
    $('[data-avis-next]', form).addEventListener('click', () => {
      if (text.value.trim().length < 10) { err(1, 'Quelques mots de plus, s’il te plaît.'); text.focus(); return; }
      err(1, ''); show(2);
    });
    text.addEventListener('input', () => { if (text.value.trim().length >= 10) err(1, ''); });
    $('[data-avis-back]', form).addEventListener('click', () => show(1));
    const done = name => { const s = $('[data-avis-name]', form); if (s && name) s.textContent = `, ${name}`; show(3); if (window.umami) umami.track('Avis envoyé'); };
    form.addEventListener('submit', async e => {
      const name = form.elements['contact[name]'], mail = form.elements['contact[email]'], ok = form.elements['contact[Accord de publication]'];
      if (text.value.trim().length < 10) { e.preventDefault(); show(1); err(1, 'Quelques mots de plus, s’il te plaît.'); return; }
      if (!name.value.trim()) { e.preventDefault(); err(2, 'Ton prénom, pour signer ton avis.'); name.focus(); return; }
      if (!MAIL.test(mail.value.trim())) { e.preventDefault(); err(2, 'Vérifie ton adresse e‑mail.'); mail.focus(); return; }
      if (!ok.checked) { e.preventDefault(); err(2, 'Coche la case pour qu’on puisse publier ton avis.'); ok.focus(); return; }
      e.preventDefault(); err(2, '');
      const btn = $('button[type=submit]', form); btn.disabled = true; btn.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' }, credentials: 'same-origin' });
        if (res.ok && /contact_posted=true/.test(res.url)) { done(name.value.trim()); return; }
        HTMLFormElement.prototype.submit.call(form);          /* Shopify wants a check (or reports an error): send it the normal way */
      } catch (x) { HTMLFormElement.prototype.submit.call(form); }
      finally { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    });
    if (inner && inner.classList.contains('is-done')) show(3);       /* back from a normal send */
    else if (inner && inner.classList.contains('has-errors')) show(2);
    else show(1);
  };

  const init = () => {
    $$('[data-avis-form]').forEach(initForm);
    const dlg = $('[data-avis-modal]');
    if (!dlg || dlg.dataset.ready) return;
    dlg.dataset.ready = '1';
    const open = () => { if (!dlg.open) { dlg.showModal(); document.documentElement.classList.add('avis-lock'); } };
    const close = () => { if (dlg.open) dlg.close(); };
    dlg.addEventListener('close', () => document.documentElement.classList.remove('avis-lock'));
    $$('[data-avis-open]').forEach(b => b.addEventListener('click', open));
    $$('[data-avis-close]', dlg).forEach(b => b.addEventListener('click', close));
    dlg.addEventListener('click', e => { if (e.target === dlg) close(); });         /* click on the dimmed backdrop */
    const inner = $('[data-avis-inner]', dlg);
    if ((inner && (inner.classList.contains('is-done') || inner.classList.contains('has-errors'))) || /^#(ecrire-un-avis|avis-(home|product))$/.test(location.hash)) open();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
